module.exports = __webpack_public_path__ + "img/Superb_sword_09.2d6d97c2.png";